import { api } from './api';
import {
  FacetsRequest,
  FacetsResponse,
  ProductSearchRequest,
  ProductSearchResponse,
} from './types';

export const productApi = api.injectEndpoints({
  endpoints: (builder) => ({
    productSearch: builder.query<ProductSearchResponse, ProductSearchRequest>({
      query: (body) => ({
        method: 'POST',
        url: `api/products/search`,
        body,
      }),
    }),

    productItemSearch: builder.query<ProductSearchResponse, ProductSearchRequest>({
      query: (body) => ({
        method: 'POST',
        url: `api/products/search-items`,
        body,
      }),
    }),
    getProductFacets: builder.query<FacetsResponse, FacetsRequest>({
      query: (params) => ({
        url: `api/products/facets`,
        body: params,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useLazyProductItemSearchQuery,
  useLazyGetProductFacetsQuery,
  useProductSearchQuery,
  useLazyProductSearchQuery,
} = productApi;
